import React from "react";
import Filmstrip from './Filmstrip';
import VideoGalleryItem from "./VideoGalleryItem";

export default function VideoGallery({mediaObjects}) {
  const videos = mediaObjects && mediaObjects.map(VideoGalleryItem);

  return (
    <div className="gallery-items-list">
      <div className="panel-group">
        <div className="video-gallery-block">
          <Filmstrip increment={500}>
            {videos}
          </Filmstrip>
        </div>
      </div>
    </div>
  );
}
